import Layout from '@components/Layout/Layout.component'
import PartnerLayout from '@components/Layout/PartnerLayout';
import { createFileRoute, Outlet, redirect } from '@tanstack/react-router'
import { isAuthenticated } from '@utils/auth';
import authStore from 'store/authStore';

export const Route = createFileRoute('/(partner)/_partner')({
    beforeLoad: () => {
      console.log('aleksa');
    },
  component: RouteComponent,
})

function RouteComponent() {
  return (
    <PartnerLayout>
        <Outlet />
    </PartnerLayout>
  )
}
